import { PersonalfragebogenNachrichtField } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/Fields/PersonalfragebogenNachrichtField';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { cn } from '@/lib/utils';
import { Checkbox, Label } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function PersonalfragebogenField() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const personalzugang = form.state.values.speicheroptionen.personalzugang;
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="speicheroptionen.personalfragebogen"
      listeners={{
        onChange: () => {
          ctx.resetDependentFields('speicheroptionen.personalfragebogen');
        },
      }}>
      {(field) => (
        <div className="flex gap-2 items-start">
          <Checkbox
            id={field.name}
            name={field.name}
            checked={field.state.value}
            disabled={!personalzugang}
            onCheckedChange={(e) => field.handleChange(!!e)}
            onBlur={field.handleBlur}
          />
          <div className="flex flex-col gap-2">
            <Label
              htmlFor={field.name}
              className={cn(
                'text-sm font-normal leading-5 w-fit',
                personalzugang ? 'text-neutrals-900' : 'text-neutrals-600',
              )}>
              {t(
                'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalfragebogen.label',
              )}
            </Label>
            {personalzugang ? (
              <span className="text-neutrals-800 text-sm font-normal leading-5">
                {t(
                  'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalfragebogen.description',
                )}
              </span>
            ) : (
              <span className="text-neutrals-700 text-xs font-normal leading-4">
                {t(
                  'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalfragebogen.info',
                )}
              </span>
            )}
            {field.state.value && <PersonalfragebogenNachrichtField />}
          </div>
        </div>
      )}
    </form.AppField>
  );
}
